export default "__VITE_ASSET__xro82BIx__"